import { render, staticRenderFns } from "./CreateLimitDialog.vue?vue&type=template&id=fd469138"
import script from "./CreateLimitDialog.vue?vue&type=script&lang=js"
export * from "./CreateLimitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports